import CryptoJS from "crypto-js";
import { secretKey } from "../config";

// 🔹 Decrypt Role from Local Storage
export const getUserRole = () => {
  const encryptedRole = localStorage.getItem("userRole");
  if (!encryptedRole) return null; // Return null if no role stored

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedRole, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8); // Convert to string
  } catch (error) {
    console.error("Error decrypting role:", error);
    return null;
  }
};
